export default __webpack_public_path__ + "assets/models/6a179d9e7af5916022966e33a572a6bc.glb";